export default __webpack_public_path__ + "static/media/ico-umbrella-fill.4ac6da76.svg";